import React, { useState } from 'react';
import ViewController from './ViewController';

function ReportsArea() {
  const [member, setMember] = useState();
  const props = { setMember, member };
  return <ViewController {...props} />;
}
export default ReportsArea;
